"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditSopTaskModal = EditSopTaskModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var sop_library_1 = require("../../../features/apis/sop-library");
var task_category_1 = require("../../../features/apis/task-category");
var client_scoped_query_1 = require("../../../utils/client-scoped-query");
var button_component_1 = require("../../ui/button-component");
var dropdown_component_1 = require("../../ui/dropdown-component");
var labeled_field_1 = require("../../ui/labeled-field");
var text_component_1 = require("../../ui/text-component");
function EditSopTaskModal(props) {
    var _this = this;
    var FREQUENCY_OPTIONS = [
        { value: "ONCE", label: "Once" },
        { value: "OFTEN", label: "Often" },
        { value: "LINKED", label: "Linked" },
    ];
    var FREQUENCY_TYPE_OPTIONS = [
        { value: "DAILY", label: "Daily" },
        { value: "WEEKLY", label: "Weekly" },
        { value: "MONTHLY", label: "Monthly" },
        { value: "YEARLY", label: "Yearly" },
    ];
    var sopLibraryId = props.sopLibraryId, sopTask = props.sopTask, onClose = props.onClose, onUpdated = props.onUpdated;
    var _a = (0, react_2.useState)(""), name = _a[0], setName = _a[1];
    var _b = (0, react_2.useState)(""), description = _b[0], setDescription = _b[1];
    var _c = (0, react_2.useState)(""), category = _c[0], setCategory = _c[1];
    var _d = (0, react_2.useState)("ONCE"), frequency = _d[0], setFrequency = _d[1];
    var _e = (0, react_2.useState)("DAILY"), frequencyType = _e[0], setFrequencyType = _e[1];
    var _f = (0, react_2.useState)("1"), frequencyInterval = _f[0], setFrequencyInterval = _f[1];
    var _g = (0, react_2.useState)(""), error = _g[0], setError = _g[1];
    var _h = (0, sop_library_1.useUpdateSopTaskMutation)(), updateSopTask = _h[0], isSaving = _h[1].isLoading;
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var taskCategoryData = (0, task_category_1.useGetTaskCategoriesQuery)({ clientId: clientId }, { skip: !sopTask || !clientId }).data;
    var categoryOptions = (0, react_2.useMemo)(function () {
        var _a;
        var seen = new Set();
        return ((_a = taskCategoryData === null || taskCategoryData === void 0 ? void 0 : taskCategoryData.content) !== null && _a !== void 0 ? _a : [])
            .filter(function (taskCategory) { return (seen.has(taskCategory.name) ? false : seen.add(taskCategory.name)); })
            .map(function (taskCategory) { return ({ value: taskCategory.name, label: taskCategory.name }); });
    }, [taskCategoryData]);
    var requestTokenRef = (0, react_2.useRef)(0);
    // A synchronous lock also catches a second click before React renders the mutation's loading state.
    var requestInFlightRef = (0, react_2.useRef)(false);
    (0, react_2.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    (0, react_2.useEffect)(function () {
        var _a, _b, _c, _d, _e, _f;
        setName((_a = sopTask === null || sopTask === void 0 ? void 0 : sopTask.name) !== null && _a !== void 0 ? _a : "");
        setDescription((_b = sopTask === null || sopTask === void 0 ? void 0 : sopTask.description) !== null && _b !== void 0 ? _b : "");
        setCategory((_c = sopTask === null || sopTask === void 0 ? void 0 : sopTask.category) !== null && _c !== void 0 ? _c : "");
        setFrequency((_d = sopTask === null || sopTask === void 0 ? void 0 : sopTask.frequency) !== null && _d !== void 0 ? _d : "ONCE");
        setFrequencyType((_e = sopTask === null || sopTask === void 0 ? void 0 : sopTask.frequencyType) !== null && _e !== void 0 ? _e : "DAILY");
        setFrequencyInterval(String((_f = sopTask === null || sopTask === void 0 ? void 0 : sopTask.frequencyInterval) !== null && _f !== void 0 ? _f : 1));
        setError("");
    }, [sopTask]);
    var handleClose = function () {
        if (requestInFlightRef.current || isSaving) {
            return;
        }
        requestTokenRef.current += 1;
        setError("");
        onClose();
    };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var trimmedName, interval, requestToken, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (requestInFlightRef.current || isSaving || !sopLibraryId || !sopTask) {
                        return [2 /*return*/];
                    }
                    setError("");
                    trimmedName = name.trim();
                    if (!trimmedName) {
                        setError("Please enter a name.");
                        return [2 /*return*/];
                    }
                    interval = Number(frequencyInterval);
                    if (frequency === "OFTEN" && (!frequencyType || !Number.isInteger(interval) || interval < 1)) {
                        setError("Please provide a frequency type and a valid interval.");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateSopTask({
                            sopLibraryId: sopLibraryId,
                            taskId: sopTask.id,
                            name: trimmedName,
                            description: description.trim() || null,
                            category: category.trim() || null,
                            frequency: frequency,
                            frequencyType: frequency === "OFTEN" ? frequencyType : undefined,
                            frequencyInterval: frequency === "OFTEN" ? interval : undefined,
                        }).unwrap()];
                case 2:
                    response = _b.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to update SOP task. Please try again.");
                        return [2 /*return*/];
                    }
                    onUpdated === null || onUpdated === void 0 ? void 0 : onUpdated();
                    requestInFlightRef.current = false;
                    handleClose();
                    return [2 /*return*/];
                case 3:
                    _a = _b.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError("Unable to update SOP task. Please try again.");
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: !!sopTask, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isSaving, isKeyboardDismissDisabled: isSaving, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[520px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isSaving, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", color: "dark-gray-1", weight: "bold", label: "Edit SOP Task" }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { className: "p-1 flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Task Name", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Task Name", value: name, onChange: setName, isRequired: true, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Task name", className: "rounded-md" }) }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Description (optional)", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Task Description", value: description, onChange: setDescription, children: (0, jsx_runtime_1.jsx)(react_1.TextArea, { placeholder: "Description (optional)", className: "rounded-md", rows: 3 }) }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Category (optional)", children: (0, jsx_runtime_1.jsx)(dropdown_component_1.DropdownComponent, { ariaLabel: "Task Category", options: categoryOptions, selectedKey: category, onSelectionChange: setCategory }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Frequency", children: (0, jsx_runtime_1.jsx)(dropdown_component_1.DropdownComponent, { ariaLabel: "Frequency", options: FREQUENCY_OPTIONS, selectedKey: frequency, onSelectionChange: function (value) { return setFrequency(value); } }) }), frequency === "OFTEN" && ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-4", children: [(0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Frequency Type", className: "flex-1", children: (0, jsx_runtime_1.jsx)(dropdown_component_1.DropdownComponent, { ariaLabel: "Frequency Type", options: FREQUENCY_TYPE_OPTIONS, selectedKey: frequencyType, onSelectionChange: function (value) { return setFrequencyType(value); } }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Interval", className: "flex-1", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Frequency Interval", value: frequencyInterval, onChange: setFrequencyInterval, children: (0, jsx_runtime_1.jsx)(react_1.Input, { type: "number", min: 1, placeholder: "Interval", className: "rounded-md" }) }) })] })), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", onPress: handleClose, isDisabled: isSaving, variant: "secondary" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Save", onPress: handleSave, isPending: isSaving, isDisabled: !sopTask || !name.trim(), color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" })] })] }) }) }) }));
}
